import expense_created from "../../../assets/notificationIcons/create.svg";
import expense_approved from "../../../assets/notificationIcons/approve.svg";
import expense_rejected from "../../../assets/notificationIcons/reject.svg";
import maintenance_created from "../../../assets/notificationIcons/create.svg";
import maintenance_approved from "../../../assets/notificationIcons/approve.svg";
import maintenance_rejected from "../../../assets/notificationIcons/reject.svg";
import transfer_created from "../../../assets/notificationIcons/create.svg";
import transfer_approved from "../../../assets/notificationIcons/approve.svg";
import transfer_rejected from "../../../assets/notificationIcons/reject.svg";
import stock_request_created from "../../../assets/notificationIcons/create.svg";
import stock_request_approved from "../../../assets/notificationIcons/approve.svg";
import stock_request_rejected from "../../../assets/notificationIcons/reject.svg";
import penalty_created from "../../../assets/notificationIcons/create.svg";
import customer_created from "../../../assets/notificationIcons/new_customer.svg";
import incentive_achieved from "../../../assets/notificationIcons/achievements.svg";
import low_stock from "../../../assets/notificationIcons/alert.svg";
import defaultIcon from "../../../assets/notificationIcons/default.png";



export const notificationIcons = {
  expense_created,
  expense_approved,
  expense_rejected,
  maintenance_created,
  maintenance_approved,
  maintenance_rejected,
  transfer_created,
  transfer_approved,
  transfer_rejected,
  stock_request_created,
  stock_request_approved,
  stock_request_rejected,
  penalty_created,
  customer_created,
  incentive_achieved,
  low_stock,
};

export const getNotificationIcon = (type) =>
  notificationIcons[type]|| defaultIcon;
